import React, { Fragment } from 'react'
import classNames from 'classnames'
import { viewportContainer } from '../../core'

import './media-with-content.scss'

class MapSection extends React.Component {
  componentDidMount() {
    viewportContainer.subscribe(this.onChange)

    setTimeout(() => {
      scrollTo(0,1)
      this.onChange()
    }, 0)
  }

  componentWillUnmount() {
    viewportContainer.unsubscribe(this.onChange)
  }

  onChange = () => {
    if (
      !this.sectionRef.current
      || !this.mediaRef.current
      || !this.contentRef.current
      || !this.spacerRef.current
    ) {
      return
    }

    const { 
      scrollAnimation,
      hideImageOnMobile,
    } = this.props

    const sectionRect = this.sectionRef.current.getBoundingClientRect()
    const mediaRect = this.mediaRef.current.getBoundingClientRect()
    const spacerRect = this.spacerRef.current.getBoundingClientRect()
    const contentRect = this.contentRef.current.getBoundingClientRect()

    const { vh } = viewportContainer

    if (scrollAnimation === 'Slide Left') {
      if (viewportContainer.vw < 768) {
        // nothing
      }
      else if (sectionRect.top <= 0) {
        const xScrollSection = sectionRect.height - vh
        const xprogress = sectionRect.top / xScrollSection
        const yprogress = (sectionRect.top + xScrollSection) / sectionRect.height

        const offsetX = Math.max(xprogress, -1) * mediaRect.width * 0.5 + 'px'
        const offsetY = Math.min(0, Math.max(yprogress, -1)) * mediaRect.height + 'px'

        if (yprogress <= 0) {
          this.contentRef.current.dataset.position = 'bottom'
          this.mediaRef.current.dataset.position = 'fixed'
          this.mediaRef.current.style.transform = `translate3d(${offsetX},0,0)`
        } else {
          this.contentRef.current.dataset.position = 'fixed'
          this.mediaRef.current.dataset.position = 'fixed'
          this.mediaRef.current.style.transform = `translate3d(${offsetX},0,0)`
        }
        
        // MOBILE
        if (viewportContainer.vw < 768) {
          if (!this.loaded) {
            // const addressBarHeight = window.screen.availHeight - vh || 20
            // console.log(addressBarHeight)
            // this.sectionRef.current.style.height = sectionRect.height + addressBarHeight + 'px'
            // this.mediaRef.current.style.height = mediaRect.height + addressBarHeight + 'px'
            // // this.contentRef.current.style.height = contentRect.height + addressBarHeight + 'px'
            // this.loaded = true
          }
          // this.mediaRef.current.style.transform = `translate3d(${offsetX},${offsetY},0)`
        } else {
          this.contentRef.current.style.transform = `translate3d(${offsetX},${offsetY},0)`
        }
      } else {
        this.contentRef.current.dataset.position = ''
        this.mediaRef.current.dataset.position = ''
        this.mediaRef.current.style.transform = `translate3d(0,0,0)`
        this.mediaRef.current.style.transform = `translate3d(0,0,0)`
      }

      return
    }

    // MOBILE
    if (viewportContainer.vw < 768 && !hideImageOnMobile) {
      this.contentRef.current.dataset.position = ''
      this.mediaRef.current.dataset.position = ''
      this.contentRef.current.style.marginTop = 0

      if (
        spacerRect.top <= (viewportContainer.vh - 300)
          && mediaRect.bottom > (viewportContainer.vh - 300)
      ) {
        this.contentRef.current.dataset.position = 'fixed'
        this.mediaRef.current.style.marginBottom ='300px'
      } else {
        this.contentRef.current.dataset.position = ''
        this.mediaRef.current.style.marginBottom = 0
      }

    // DESKTOP
    } else {
      if (sectionRect.top <= viewportContainer.vh - 300) {
        this.contentRef.current.dataset.inView = true
      } else {
        this.contentRef.current.dataset.inView = false
      }

      if (mediaRect.height === contentRect.height) {  
        // no scroll effect
      } else if (sectionRect.top <= 0) {
        if (sectionRect.bottom < viewportContainer.vh) {
          this.mediaRef.current.dataset.position = 'bottom'
          this.contentRef.current.style.marginTop = 0
        } else {
          this.mediaRef.current.dataset.position = 'fixed'
          this.contentRef.current.style.marginTop = 0
        }
      } else {
        this.mediaRef.current.dataset.position = 'top'
        this.contentRef.current.style.marginTop = 0
      }
    }
  }

  mediaRef = React.createRef()
  contentRef = React.createRef()
  sectionRef = React.createRef()
  spacerRef = React.createRef()

  render() {
    const { 
      media, 
      content,
      mediaLeftDesktop,
      contentTheme,
      scrollAnimation,
      hideImageOnMobile,
      isFullHeight,
      anchor,
      isStatic,
    } = this.props

    const useFullHeight = (isFullHeight === undefined || isFullHeight === null)
      ? true
      : isFullHeight

    const sectionClass = classNames(
      'section',
      useFullHeight && 'use-full-height',
      mediaLeftDesktop && 'media-left',
      contentTheme && `content-theme-${contentTheme} `,
      scrollAnimation && `animate-${scrollAnimation.split(' ').join('-')}`,
      hideImageOnMobile && 'hide-image-on-mobile',
      isStatic && 'is-static'
    )

    return (
      <Fragment>
        <section styleName={`${sectionClass} `} ref={this.sectionRef} id={anchor}>
          <div styleName="spacer" ref={this.spacerRef} />
          <div styleName="media" ref={this.mediaRef}>
            <div styleName="inner">
              {media}
            </div>
          </div>
          <div styleName="content" ref={this.contentRef}>
            <div styleName="inner">
              {content}
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default MapSection